import { connect } from 'react-redux';
import { getUrlPdfContrat } from '../../../../../redux/selectors/init/init.selectors';
import AvenantDejaPasse from './AvenantDejaPasse';

const mapStateToProps = (state) => {
    return {
        urlPdfContrat: getUrlPdfContrat(state),
    };
};

const AvenantDejaPasseContainer = connect(mapStateToProps)(AvenantDejaPasse);

export default AvenantDejaPasseContainer;
